import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FUNCOES = [["financeiro", "Financeiro"], ["analista_cadastro", "Analista de Cadastro"], ["analista_contrato", "Analista de Contrato"], ["agente_campo", "Agente de Campo — Cobrador"]];
export const REGIOES = ["Sul", "Leste", "Oeste", "Norte"];

export function ResponsaveisConfig({ company, setCompany }) {
  const r = company.responsaveis || {};
  const setR = (k, v) => setCompany((p) => ({ ...p, responsaveis: { ...(p.responsaveis || {}), [k]: v } }));
  return (
    <div className="mt-6 space-y-4" data-testid="responsaveis-config">
      <div>
        <h4 className="font-bold">Responsáveis por função (identificação nos textos)</h4>
        <p className="text-xs text-slate-500">Nomes exibidos nas mensagens ({"{{RESPONSAVEL_FINANCEIRO}}"}, {"{{ANALISTA_CADASTRO}}"}, {"{{ANALISTA_CONTRATO}}"}, {"{{AGENTE_CAMPO}}"}, {"{{REGIAO_AGENTE}}"}). Não concedem acesso; a auditoria registra o usuário autenticado.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        {FUNCOES.map(([k, label]) => (
          <div key={k}><Label className="text-xs">{label}</Label><Input value={r[k] || ""} onChange={(e) => setR(k, e.target.value)} data-testid={`resp-${k}`} className="mt-1" placeholder="Nome do responsável" /></div>
        ))}
        <div><Label className="text-xs">Região do Agente de Campo</Label>
          <Select value={r.agente_regiao || "none"} onValueChange={(v) => setR("agente_regiao", v === "none" ? "" : v)}>
            <SelectTrigger data-testid="resp-agente-regiao" className="mt-1"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="none">—</SelectItem>{REGIOES.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
          </Select>
        </div>
      </div>
      <div className="flex items-center justify-between bg-slate-50 rounded-lg px-4 py-3 border">
        <div><p className="text-sm font-medium">Acordos do Agente de Campo exigem aprovação</p><p className="text-xs text-slate-500">Quando ativo, o acordo fica “Pendente de análise” sem alterar dívida, contrato ou parcelas até a aprovação do administrador ou do Financeiro autorizado.</p></div>
        <Switch checked={!!company.acordo_exige_aprovacao} onCheckedChange={(v) => setCompany((p) => ({ ...p, acordo_exige_aprovacao: v }))} data-testid="acordo-exige-aprovacao" />
      </div>
      <div>
        <Label className="text-xs">Portal — data limite da transição para senha pessoal (clientes antigos ainda entram com CPF + nascimento até esta data)</Label>
        <Input type="date" value={company.portal_transicao_limite || ""} onChange={(e) => setCompany((p) => ({ ...p, portal_transicao_limite: e.target.value }))} data-testid="portal-transicao-limite" className="mt-1 max-w-xs" />
      </div>
    </div>
  );
}
